module.exports = __webpack_public_path__ + "img/5.a464bc02.png";